import angular from 'angular';

module.exports = angular.module('common.filters.newlines', [])
.filter('newlines', function($sce) {
  return function(text) {
    if (!text) return null;
    return $sce.trustAsHtml(text.replace(/\n/g, '<br />'));
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/newlines.js
 **/